import { inject, Injectable } from '@angular/core';

import { take } from 'rxjs';

import { DialogService, DialogWidth } from '@core/user-interface-legacy';
import { TicketsDataService } from '@tellent-ask-hr/tickets-logic';
import { TicketDialogComponent } from '@tellent-ask-hr/tickets-smart-ui';

@Injectable({ providedIn: 'root' })
export class TicketDialogService {
  private readonly ticketDataService = inject(TicketsDataService);
  private readonly dialogService = inject(DialogService);

  public openTicketDialog(templateId: number): void {
    this.ticketDataService
      .loadTicketById(templateId)
      .pipe(take(1))
      .subscribe(({ isSuccess, success }) => {
        if (!isSuccess) return;

        this.dialogService.openDialog(
          TicketDialogComponent,
          { ticket: this.ticketDataService.getTicketById(templateId) },
          {
            width: DialogWidth.LargeX,
          },
        );
      });
  }
}
